import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20luxurious%20abstract%20background%20with%20flowing%20warm%20golden%20and%20deep%20crimson%20curves%20elegant%20premium%20gaming%20atmosphere%20soft%20glowing%20light%20particles%20sophisticated%20modern%20design&width=1920&height=900&seq=hero-bg&orientation=landscape"
          alt="j9官方平台 - 综合娱乐平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-400/30 mb-8">
          <i className="ri-shield-check-line text-accent-400 text-sm"></i>
          <span className="text-accent-300 text-sm font-medium">正规运营 · 安全可靠 · 500万+用户信赖</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          {heroData.title}
        </h1>

        <p className="text-lg md:text-xl text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          {heroData.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 rounded-lg bg-accent-500 text-background-50 font-semibold text-base hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/25"
          >
            {heroData.cta_primary}
          </a>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-lg border border-background-50/30 text-background-50 font-medium text-base hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap"
          >
            {heroData.cta_secondary}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}